module.exports = __webpack_public_path__ + "img/005王利雄.987d0bf3.png";